// extracted by mini-css-extract-plugin
export default {"root":"Quote__root--bpb8u","footer":"Quote__footer--rcy6h","right":"Quote__right--BXwF_","total":"Quote__total--TGsVg"};